import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent, AccordionPanelComponent } from 'ngx-bootstrap/accordion';
import { TimesheetEntryNgrxSpectorComponent } from '../timesheet-entry-spector/timesheet-entry-ngrx-spector.component';
import {
    AddressState,
    NotificationState,
    NotificationStateUtilities,
    selectConfirmations,
    TimesheetWorkEntryState,
} from '../../../state';
import { Store } from '@ngrx/store';

@Component({
    selector: 'pace-core-workentry-ngrx-spector',
    imports: [CommonModule, AccordionPanelComponent, AccordionComponent, TimesheetEntryNgrxSpectorComponent],
    templateUrl: './workentry-ngrx-spector.component.html',
    styleUrl: './workentry-ngrx-spector.component.css',
})
export class WorkentryNgrxSpectorComponent {
    private readonly store = inject(Store);
    public addressesById = input.required<Map<string, AddressState>>();
    public workEntries = input.required<TimesheetWorkEntryState[]>();
    public notification = input.required<NotificationState | undefined>();
    protected customerAddress = computed(() => {
        const addressId = this.notification()?.customerAddressId;
        if (!addressId) {
            return undefined;
        }
        return this.addressesById()?.get(addressId);
    });
    protected submittedConfirmations = this.store.selectSignal(selectConfirmations);
    protected isSubmitted = computed(() => {
        const notificationId = this.notification()?.notificationId;
        if (!notificationId) {
            return false;
        }
        return this.submittedConfirmations().some((confirmation) =>
            NotificationStateUtilities.compare(confirmation.notificationId, notificationId),
        );
    });

    public title = computed(() => {
        const n = this.notification();
        if (!n) {
            return 'undefined notification';
        }
        const id = n.notificationId?.frontId || 'no frontid';
        const notificationNumber = n.notificationId?.qmNum ? ` :: Notification ${n.notificationId.qmNum}` : '';
        const taskNumber = n.notificationId?.maNum ? ` :: Task ${n.notificationId.maNum}` : '';
        const address = this.customerAddress();
        const cust = address?.contactName1 ? ` :: ${address.contactName1}` : '';
        const cust2 = address?.contactName2 ? ` :: ${address.contactName2}` : '';
        return `[${id}]${notificationNumber}${taskNumber}${cust}${cust2}`;
    });
}
